<template>
  <NuxtLink
    :to="to"
    class="category-card group relative overflow-hidden rounded-lg aspect-[4/3] block"
    :style="{ backgroundImage: `url(${image})` }"
  >
    <div class="absolute inset-0 bg-gradient-to-br from-black/70 to-black/40 group-hover:from-black/50 group-hover:to-black/20 transition-all"></div>
    <div class="relative h-full flex flex-col items-center justify-center text-white">
      <h3 class="text-center text-2xl md:text-3xl font-bold group-hover:scale-110 transition-transform">
        {{ title }}
      </h3>
      <p v-if="description" class="text-sm opacity-90 mt-2">{{ description }}</p>
    </div>
    <!-- Hover effect overlay -->
    <div class="absolute inset-0 bg-white/5 group-hover:bg-white/0 transition-all"></div>
  </NuxtLink>
</template>

<script setup lang="ts">
defineProps<{
  title: string
  image: string
  to: string
  description?: string
}>()
</script>

<style scoped>
.category-card {
  background-size: cover;
  background-position: center;
}
</style>

